import React, { useEffect, useState } from 'react';
import client from '../../../../utils/prismicHelpers';
import * as queries from "../../../../utils/prismicQueries";

const Guidelines = () => {
    const [guideLines, setGuideInfo] = useState(null);
    useEffect(() => {
        client
            .query({
                query: queries.guideLines,
            })
            .then((response) => {
                const guideDoc = response.data.allGis.edges[0].node;
                setGuideInfo(guideDoc);


            })
            .catch((error) => {
                console.error(error);
            });
    });

    return (
        <div>
            <h3 className="subtitle ">{guideLines?.tilte[0]?.text}</h3>
            <ul>
                {guideLines?.description_list?.map((description, index) => <li key={index + 1} className="body-text pt-2">{description.para}</li>)}
            </ul>
            <div className="scroing pt-4">
                <h5 className="robot-challenge-title">{guideLines?.sub_title[0]?.text}</h5>
                <p className="body-text">
                    <span
                        className=" fw-bold  pb-1 secondary-text">{guideLines?.sub_des[0]?.text.slice(0, 5)}
                    </span>
                    <span
                    >{guideLines?.sub_des[0]?.text.slice(5, 125)}
                    </span>
                    <span
                        className=" d-block " > {guideLines?.sub_des[0]?.text.slice(125, 12500)}
                    </span>

                </p>

                <ol>
                    {guideLines?.scoring?.map((listInfo, index) => <li key={index + 1}className="body-text"> <span>{index + 1}.</span> {listInfo?.desc[0]?.text}</li>)}
                </ol>

                <h5 className="robot-challenge-title">{guideLines?.footer_title[0]?.text}</h5>
                <p className="body-text">{guideLines?.footer_des[0]?.text}</p>

            </div>

        </div>
    );
};

export default Guidelines;